import { NgModule } from '@angular/core';
import { BasicInputComponent } from './basic-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorInputDirective } from 'src/app/directives/errorInput.directive';
import { TextMaskModule } from 'angular2-text-mask';
import { ImportModule } from 'src/app/import.module';
import { TranslatePipeModule } from 'src/app/pipes/translate.module';

@NgModule({
  imports: [
    ImportModule,
    FormsModule,
    ReactiveFormsModule,
    TextMaskModule,
    TranslatePipeModule,
  ],
  declarations: [BasicInputComponent, ErrorInputDirective],
  exports: [BasicInputComponent],
})
export class BasicInputModule {}
